<template>
  <b-modal size="xl" centered  scrollable id="modal-categorie" ref="modal-categorie" :title="modalTitle" @hidden="resetForm">
    <b-form>
      <b-form-group
          label='Libellé'
          label-for='libelle'
        >
        <b-form-input id='libelle' type='text' v-model="libelle" :class="{hasError: errors.libelle !== ''}"></b-form-input>
        <span class="field-error">{{ errors.libelle }}</span>
      </b-form-group>
      <b-form-group
          description='En minuscule sans accent ni espace (mettre un _ à la place)'
          label='Libellé technique'
          label-for='libelle_technique'
        >
        <b-form-input id='libelle_technique' type='text' v-model="libelle_technique" :disabled="!isEmpty(selectedCategory)" :class="{hasError: errors.libelle_technique !== ''}"></b-form-input>
        <span class="field-error">{{ errors.libelle_technique }}</span>
      </b-form-group>
    </b-form>
    <template #modal-footer>
      <div class="w-100">
        <b-button
          variant="secondary"
          size="md"
          class="float-left"
          @click="resetForm; $bvModal.hide('modal-categorie')"
        >
          Fermer
        </b-button>
        <b-button type="button" @click="submitForm" size="md" variant="primary" class="float-right">
          <i class="fa fa-save"></i> Enregistrer
        </b-button>
      </div>
    </template>
  </b-modal>
</template>
 
<script>
  import {isEmpty} from "@/utils/fileHelper";
 
export default {
  props: {
    selectedCategory: {
      type: Object
    },
  },
  data() {
    return {
      isEmpty,
      libelle: '',
      libelle_technique: '',
      modalTitle: 'Création d\'une catégorie de document',
      errors: {
        libelle: '',
        libelle_technique: '',
        categorie_id: '',
      }
    }
  },
  watch: {
    selectedCategory(value) {
      if (!isEmpty(value)) {
        this.modalTitle = 'Modification de la catégorie de document';
        this.libelle = this.selectedCategory.libelle;
        this.libelle_technique = this.selectedCategory.libelle_technique;
      }
    },
  },
  methods: {
    submitForm() {
      if (this.validateData()) {
        let self = this;
        let dataPost = {};

        dataPost.libelle = this.libelle;
        dataPost.libelle_technique = this.libelle_technique;
        dataPost.categoryId = !isEmpty(this.selectedCategory) ? this.selectedCategory.id : '';

        this.$store.commit("IS_LOADING", true);
        this.$axios
          .post("/espaceBibliotheque/categorie", dataPost)
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            this.$refs['modal-categorie'].hide();
            this.resetForm();
            // this.getCategories();
            this.$event.emit('refresh-categorie-document');
            // event après nouvelle catégorie dans le formulaire de création de document
            this.$event.emit('refresh-after-new-categorie', response.data.categorie);
            let title = !isEmpty(this.selectedCategory) ? 'Modification avec succès' : 'Création avec succès';
            let texte = !isEmpty(this.selectedCategory) ? 'La catégorie a bien été modifiée' : 'La catégorie a bien été créée';
            this.$swal({
              position: "top",
              type: "success",
              title: title,
              text: texte,
              showConfirmButton: false,
              timer: 5000
            });
          })
          .catch(function(error) {
            self.$store.commit("IS_LOADING", false);
            let text = 'Une erreur est survenue pendant la création de la catégorie, si le problème persiste merci de contacter le support DOSI';
            if (!isEmpty(error) && error.response && error.response.status === 403) {
              text = error.response.data.message;
              self.errors.libelle_technique = 'Libellé technique déjà utilisé';
            }
            self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text: text,showConfirmButton: false, timer: 10000});
          });
      }
    },
    resetForm() {
      this.libelle = '';
      this.libelle_technique = '';
    },
    clearErrors() {
      this.errors.libelle = '';
      this.errors.libelle_technique = '';
    },
    validateData() {
      this.clearErrors();
      let valid = true;
      if (isEmpty(this.libelle)) {
        this.errors.libelle = 'Le libellé est obligatoire';
        valid = false;
      }
      if (isEmpty(this.libelle_technique)) {
        this.errors.libelle_technique = "Le libellé technique est obligatoire";
        valid = false;
      }
      return valid;
    },
  }
}
</script>
<style scoped>
</style>